import isNumber from 'lodash/isNumber'

export interface MapMarker {
  latitude?: number | null
  longitude?: number | null
}

export const getMapBoundsV2 = (marks: MapMarker[]) => {
  if (!marks || marks.length === 0) {
    return null
  }

  const { maxLat, maxLng, minLat, minLng } = marks.reduce((acc, mark) => ({
    minLat: Math.min(acc.minLat, mark.latitude || Infinity),
    maxLat: Math.max(acc.maxLat, mark.latitude || -Infinity),
    minLng: Math.min(acc.minLng, mark.longitude || Infinity),
    maxLng: Math.max(acc.maxLng, mark.longitude || -Infinity),
  }), {
    minLat: Infinity,
    maxLat: -Infinity,
    minLng: Infinity,
    maxLng: -Infinity,
  })

  const bounds = {
    min: new google.maps.LatLng(minLat, minLng),
    max: new google.maps.LatLng(maxLat, maxLng),
  }

  const center = new google.maps.LatLng(
    (minLat + maxLat) / 2,
    (minLng + maxLng) / 2,
  )

  return { bounds, center }
}

export const createMapScript = (setMapOnUpdate: () => void) => {
  const mapSrc = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyB3ZmhBtSlnDPLnTQlzKq_uqUPKfyu-FbU'
  const existingScript = document.querySelector(`script[src="${mapSrc}"]`)

  if (existingScript) {
    setMapOnUpdate()
    return
  }

  const googleMapScript = document.createElement('script')
  googleMapScript.setAttribute(
    'src',
    mapSrc,
  )

  googleMapScript.addEventListener('load', () => {
    setMapOnUpdate()
  })

  document.body.appendChild(googleMapScript)
}

export const addMarksToMap = <T extends MapMarker>(
  gMap: google.maps.Map,
  marks: T[],
  identifier: keyof T,
  handleMarkerClick: (
    mark: T,
    gMap: google.maps.Map,
    gMarker: google.maps.Marker,
  ) => void,
  selectedPointId?: string | null,
) => {
  marks.forEach((place) => {
    if (isNumber(place.latitude) && isNumber(place.longitude)) {
      const gMarker = new google.maps.Marker({
        position: {
          lat: place.latitude!,
          lng: place.longitude!,
        },
        map: gMap,
        icon:
            place[identifier] === selectedPointId
              ? 'https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/blt398dc08a40ecd085/map-pin-droppoint-selected.png'
              : 'https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/blt0942aaba380e4b7b/map-pin-droppoint.png',
      })
      gMarker.addListener('click', () => {
        handleMarkerClick(place, gMap, gMarker)
      })
    }
  })
}
